export default {
    logo: "Franchise logo",
    description: "Upload your franchise logo. The Franchise logo is displayed on info screens, the admin platform, in emails and for users when they see your locations",
    current: "Current",
    noLogo: "You have not uploaded a logo",
    uploaded: "The image has been added",
}